import { Component, Input, OnInit } from '@angular/core';
import { IProfile } from '../../interfaces/profile.interface';
import { ProfileService } from '../../services/profile.service';
import { AuthConnectionService } from '../../services/auth-connection.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() profile: IProfile | null = null;

  constructor(
    private profileService: ProfileService,
    private authConnectionService: AuthConnectionService,
    private router: Router
  ) { }

  ngOnInit() {
    this.profileService.getProfile().subscribe({
      next: (data) => {
        const token = localStorage.getItem('access_token');
        this.profile = data;
      },
      error: (error) => {
        console.error('Error al obtener los datos del perfil', error);
      }
    });
  }

  onLogoutClick() {
    this.authConnectionService.logout().subscribe(() => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('me');
      console.log('adios mundo');
      this.router.navigate(['/login']);
    });
  }



}

